var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verify-container"},[_c('vab-verify',{ref:"slideDiv",attrs:{"w":350,"slider-text":_vm.text,"h":175},on:{"success":_vm.handleSuccess,"fail":_vm.handleError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }